var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-lk-how-work-with-leads"},[_c('h4',{staticClass:"t-lk-how-work-with-leads__title"},[_vm._v(_vm._s(_vm.$root.staticText.lk.leadsThird2))]),_vm._v(" "),_c('div',{staticClass:"t-lk-how-work-with-leads__text"},[_vm._v("\n    "+_vm._s(_vm.$root.staticText.lk.leadsThirdText2)+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"t-lk-how-work-with-leads__btn",on:{"click":function($event){return _vm.$emit('modal:close')}}},[_vm._v(_vm._s(_vm.$root.staticText.lk.lkModalBtn))])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/how-work-with-leads.vue?vue&type=template&id=3efce5e4&
// module id = 1465
// module chunks = 0